import { render } from "./SePlaceholder.vue?vue&type=template&id=126e52ca&scoped=true"
const script = {}

import "./SePlaceholder.vue?vue&type=style&index=0&id=126e52ca&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-126e52ca"]])

export default __exports__